import PropTypes from "prop-types";
import { useStateMachine } from "little-state-machine";
import { useCheckoutState } from "@hooks/useCheckout";
import { Button } from "@components/Button";
import { Waitlist } from "../Waitlist";
import { useTranslation } from "next-i18next";
import styles from "./styles/footer.module.css";

export function Footer({ addToCart, comingSoon, showWaitlist, waitlistMessage }) {
  const { t } = useTranslation("productpage");
  const { state } = useStateMachine();
  const { loading } = useCheckoutState();

  const displayButton = () => {
    if (!state["variant"].availableForSale || showWaitlist) {
      return (
        <Waitlist
          variantID={state["variant"].id}
          variantTitle={state["variant"].title}
          productTitle={state["productGroup"].title.replace(/(Wo)?[Mm]en['’]?s /g, "")}
          isComingSoon={comingSoon}
          waitlistMessage={waitlistMessage}
        />
      );
    }
    return (
      <Button
        handleClick={addToCart}
        isDisabled={loading}
        description="addToBag"
        descriptionText="Click to add to bag"
      >
        {loading ? t("adding") : t("add-to-bag-button")}
      </Button>
    );
  };
  return (
    <div className={styles.wrapper} data-cy="addToBag">
      <div className={styles.buttonContainer}>{displayButton()}</div>
    </div>
  );
}

Footer.propTypes = {
  waitlistMessage: PropTypes.string,
  comingSoon: PropTypes.bool.isRequired,
  addToCart: PropTypes.func.isRequired,
};
